<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Детали транзакции
      <router-link class="btn btn-primary" :to="{ name: 'transaction-edit', params: { transaction_id: $route.params.transaction_id }}">Редактировать информацию</router-link>
    </h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'client-details', params: { client_id: $route.params.client_id } }">← Назад к Транзакциям</router-link>
    </div>

    <transactionDetail :transaction-id="$route.params.transaction_id" />

  </div>
</template>

<script>
import transactionDetail from '@/components/details/transaction/TransactionDetail'

export default {
  name: 'client-transaction-details',
  components: { transactionDetail }
}
</script>


// WEBPACK FOOTER //
// ClientTransactionDetails.vue?62b0e0d4